// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LeadResourceCallForm-module__root___fDues {
  background: #ffffff;
  border-bottom: 1px solid #f4f4f5;
  box-sizing: border-box;
  max-width: 100%;
  padding: 12px 16px;
  width: 100%;
}

.LeadResourceCallForm-module__page___RGePU {
  border-bottom: 0;
  padding: 12px 0 24px;
}

.LeadResourceCallForm-module__header___CD596 {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.LeadResourceCallForm-module__eyebrow___LE0Vf {
  color: #71717a;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.05em;
  line-height: 1;
  margin-bottom: 4px;
  text-transform: uppercase;
}

.LeadResourceCallForm-module__title___s2uE5 {
  color: #18181b;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  margin: 0;
}

.LeadResourceCallForm-module__message___aCNdz,
.LeadResourceCallForm-module__error___jGZqo {
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.4;
  padding: 10px 12px;
}

.LeadResourceCallForm-module__message___aCNdz {
  background: #fafafa;
  color: #52525b;
}

.LeadResourceCallForm-module__error___jGZqo {
  background: #fef2f2;
  color: #b91c1c;
}

.LeadResourceCallForm-module__lockedGrid___cK0lL {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-bottom: 12px;
}

.LeadResourceCallForm-module__lockedValue___Nx_sU {
  min-width: 0;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #fafafa;
  padding: 8px 10px;
}

.LeadResourceCallForm-module__lockedValue___Nx_sU span {
  display: block;
  color: #71717a;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: 3px;
  text-transform: uppercase;
}

.LeadResourceCallForm-module__lockedValue___Nx_sU strong {
  display: block;
  color: #3f3f46;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.LeadResourceCallForm-module__section___Bs1D8 {
  border-top: 1px solid #f4f4f5;
  padding-top: 12px;
}

.LeadResourceCallForm-module__section___Bs1D8 + .LeadResourceCallForm-module__section___Bs1D8 {
  margin-top: 12px;
}

.LeadResourceCallForm-module__section___Bs1D8 h4 {
  color: #52525b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  margin: 0 0 10px;
  text-transform: uppercase;
}

.LeadResourceCallForm-module__grid___XbnJP {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.LeadResourceCallForm-module__nativeField___J68O_ {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.LeadResourceCallForm-module__nativeField___J68O_ span {
  color: #3f3f46;
  font-size: 12px;
  font-weight: 500;
}

.LeadResourceCallForm-module__nativeField___J68O_ input {
  box-sizing: border-box;
  width: 100%;
  height: 38px;
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  background: #ffffff;
  color: #18181b;
  font-size: 14px;
  padding: 0 10px;
}

.LeadResourceCallForm-module__nativeField___J68O_ input:focus {
  border-color: #71717a;
  outline: none;
}

.LeadResourceCallForm-module__checkboxGrid___psktj {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.LeadResourceCallForm-module__checkboxField___eJL5y {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #fafafa;
  color: #3f3f46;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  min-width: 0;
  padding: 8px 10px;
}

.LeadResourceCallForm-module__checkboxField___eJL5y input {
  flex: 0 0 auto;
}

.LeadResourceCallForm-module__checkboxField___eJL5y span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 980px) {
  .LeadResourceCallForm-module__grid___XbnJP,
  .LeadResourceCallForm-module__checkboxGrid___psktj {
    grid-template-columns: 1fr;
  }
  .LeadResourceCallForm-module__lockedGrid___cK0lL {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 560px) {
  .LeadResourceCallForm-module__lockedGrid___cK0lL {
    grid-template-columns: 1fr;
  }
}
.LeadResourceCallForm-module__headerActions___tk126 {
  align-items: center;
  display: flex;
  gap: 8px;
}

.LeadResourceCallForm-module__requirementsPending___Hkz_q {
  background-color: #fdf3e7;
  border: 1px solid #e8c9a0;
  border-radius: 6px;
  color: #8a5a1a;
  font-size: 12px;
  margin-top: 12px;
  padding: 10px 12px;
}

.LeadResourceCallForm-module__requirementsReady___G1us_ {
  background-color: #eef5f0;
  border: 1px solid #cfe1d6;
  border-radius: 6px;
  color: #2f6f4f;
  font-size: 12px;
  margin-top: 12px;
  padding: 10px 12px;
}

.LeadResourceCallForm-module__nativeInputError___sXURt {
  border-color: #c0392b !important;
}

.LeadResourceCallForm-module__nativeError___WETHr {
  color: #c0392b;
  font-size: 11px;
  font-style: normal;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/LeadResourceCallForm/LeadResourceCallForm.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,gCAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;EACA,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AACF;;AAEA;;EAEE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,gDAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AACF;;AAEA;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AACF;;AAEA;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,6BAAA;EACA,iBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,gDAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AACF;;AAEA;EACE,qBAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,gDAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE;;IAEE,0BAAA;EACF;EAEA;IACE,gDAAA;EAAF;AACF;AAGA;EACE;IACE,0BAAA;EADF;AACF;AAIA;EACE,mBAAA;EACA,aAAA;EACA,QAAA;AAFF;;AAKA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,gCAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AAFF","sourcesContent":[".root {\n  background: #ffffff;\n  border-bottom: 1px solid #f4f4f5;\n  box-sizing: border-box;\n  max-width: 100%;\n  padding: 12px 16px;\n  width: 100%;\n}\n\n.page {\n  border-bottom: 0;\n  padding: 12px 0 24px;\n}\n\n.header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.eyebrow {\n  color: #71717a;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  line-height: 1;\n  margin-bottom: 4px;\n  text-transform: uppercase;\n}\n\n.title {\n  color: #18181b;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.3;\n  margin: 0;\n}\n\n.message,\n.error {\n  border-radius: 6px;\n  font-size: 12px;\n  line-height: 1.4;\n  padding: 10px 12px;\n}\n\n.message {\n  background: #fafafa;\n  color: #52525b;\n}\n\n.error {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.lockedGrid {\n  display: grid;\n  gap: 8px;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  margin-bottom: 12px;\n}\n\n.lockedValue {\n  min-width: 0;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  background: #fafafa;\n  padding: 8px 10px;\n}\n\n.lockedValue span {\n  display: block;\n  color: #71717a;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 1.2;\n  margin-bottom: 3px;\n  text-transform: uppercase;\n}\n\n.lockedValue strong {\n  display: block;\n  color: #3f3f46;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.35;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.section {\n  border-top: 1px solid #f4f4f5;\n  padding-top: 12px;\n}\n\n.section + .section {\n  margin-top: 12px;\n}\n\n.section h4 {\n  color: #52525b;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  margin: 0 0 10px;\n  text-transform: uppercase;\n}\n\n.grid {\n  display: grid;\n  gap: 10px;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.nativeField {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.nativeField span {\n  color: #3f3f46;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.nativeField input {\n  box-sizing: border-box;\n  width: 100%;\n  height: 38px;\n  border: 1px solid #d4d4d8;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #18181b;\n  font-size: 14px;\n  padding: 0 10px;\n}\n\n.nativeField input:focus {\n  border-color: #71717a;\n  outline: none;\n}\n\n.checkboxGrid {\n  display: grid;\n  gap: 8px;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.checkboxField {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  background: #fafafa;\n  color: #3f3f46;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  min-width: 0;\n  padding: 8px 10px;\n}\n\n.checkboxField input {\n  flex: 0 0 auto;\n}\n\n.checkboxField span {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@media (max-width: 980px) {\n  .grid,\n  .checkboxGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .lockedGrid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 560px) {\n  .lockedGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.headerActions {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n}\n\n.requirementsPending {\n  background-color: #fdf3e7;\n  border: 1px solid #e8c9a0;\n  border-radius: 6px;\n  color: #8a5a1a;\n  font-size: 12px;\n  margin-top: 12px;\n  padding: 10px 12px;\n}\n\n.requirementsReady {\n  background-color: #eef5f0;\n  border: 1px solid #cfe1d6;\n  border-radius: 6px;\n  color: #2f6f4f;\n  font-size: 12px;\n  margin-top: 12px;\n  padding: 10px 12px;\n}\n\n.nativeInputError {\n  border-color: #c0392b !important;\n}\n\n.nativeError {\n  color: #c0392b;\n  font-size: 11px;\n  font-style: normal;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `LeadResourceCallForm-module__root___fDues`,
	"page": `LeadResourceCallForm-module__page___RGePU`,
	"header": `LeadResourceCallForm-module__header___CD596`,
	"eyebrow": `LeadResourceCallForm-module__eyebrow___LE0Vf`,
	"title": `LeadResourceCallForm-module__title___s2uE5`,
	"message": `LeadResourceCallForm-module__message___aCNdz`,
	"error": `LeadResourceCallForm-module__error___jGZqo`,
	"lockedGrid": `LeadResourceCallForm-module__lockedGrid___cK0lL`,
	"lockedValue": `LeadResourceCallForm-module__lockedValue___Nx_sU`,
	"section": `LeadResourceCallForm-module__section___Bs1D8`,
	"grid": `LeadResourceCallForm-module__grid___XbnJP`,
	"nativeField": `LeadResourceCallForm-module__nativeField___J68O_`,
	"checkboxGrid": `LeadResourceCallForm-module__checkboxGrid___psktj`,
	"checkboxField": `LeadResourceCallForm-module__checkboxField___eJL5y`,
	"headerActions": `LeadResourceCallForm-module__headerActions___tk126`,
	"requirementsPending": `LeadResourceCallForm-module__requirementsPending___Hkz_q`,
	"requirementsReady": `LeadResourceCallForm-module__requirementsReady___G1us_`,
	"nativeInputError": `LeadResourceCallForm-module__nativeInputError___sXURt`,
	"nativeError": `LeadResourceCallForm-module__nativeError___WETHr`
};
module.exports = ___CSS_LOADER_EXPORT___;
